export default function convert(unitText) {
    let unit;
    switch (unitText.toLowerCase()) {
        case 'gallons':
            unit = 'G';
            break;
        case 'ccf':
            unit = 'CF';
            break;
        case 'cubic_m':
        case 'cubic_meters':
            unit = 'CM';
            break;
        case 'tons':
            unit = 'Tons';
            break;
        case 'liters':
        default:
            unit = 'L';
            break;
    }
    return unit;
}

export const DEFAULT_VOLUME_UNIT = 'LITERS';
export const DEFAULT_CURRENCY_UNIT = 'ILS';